<template>
    <div>
      <div>
        <jd-tips>
          <p>
            1.令牌，是一个用户特权集合(可以是折扣价格、或者满赠、满减等)，能够起到将用户与某个促销活动关联的作用；
          </p>
          <p>
            2.导入令牌时，填写的信息请务必与官方申请的信息一致，否则会导致活动异常，引起客诉;
          </p>
        </jd-tips>
        <div class="topTip">
          <div class="beans">
            <img
              style="width: 80px;"
              src="@/assets/images/integralCenter/lin.png"
            />
          </div>
          <div class="beans">
            <span>待生效令牌数量：</span>
            <span style="color: #2768ff">{{ pendingNum }}</span>
          </div>
          <div class="beans">
            <span>已生效令牌数量：</span>
            <span style="color: #2768ff">{{ effectiveNum }}</span>
          </div>
          <div class="beans">
            <el-button
               type="primary"
               style="margin: 35px 0 40px 30px"
               @click="addToken('','1')"
            >添加令牌</el-button>
           </div>
        </div>
        <!-- tab切惠安 -->
        <div style="margin-left: 30px;">
         <el-tabs v-model="tabActive" type="card" @tab-click="handleClick">
		    	<el-tab-pane label="当前令牌" name="1"></el-tab-pane>
            <el-tab-pane label="历史令牌" name="2"></el-tab-pane>
		     </el-tabs>
        </div>
        <input-form
          ref="inputForm"
          style="margin: 40px 20px"
          :inputData="tabActive==1?inputData:inputDatas"
          @toParentVal="search"
          :btnPosition1="true"
        ></input-form>
      </div>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        style="width: 95%;margin: 0 auto"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
      >
        <template slot="empty">
          <div>
            <img
              src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png"
            />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column label="令牌信息" width="180">
          <template slot-scope="scope">
            <div>令牌名称：{{ scope.row.name }}</div>
            <div>令牌ID：{{ scope.row.tokenId }}</div>
            <div>令牌密钥：{{ scope.row.secretKey }}</div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180">
          <template slot-scope="scope">
            <div>{{ scope.row.createTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="令牌描述" width="180">
          <template slot-scope="scope">
            <el-tooltip
                  class="item"
                  effect="light"
                  :content="scope.row.description"
                  placement="bottom"
                >
                  <div class="remark-tip">
                    {{ scope.row.description }}
                  </div>
                </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="令牌有效时间" width="190">
          <template slot-scope="scope">
            <div>起：{{ scope.row.startTime }}</div>
            <div>止：{{ scope.row.endTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="时效状态" width="100">
          <template slot-scope="scope">
            <div>{{ scope.row.status==1?'待生效':scope.row.status==2?'已生效':scope.row.status==3?'已结束':'' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="促销活动类型" width="180">
        <template #default="{row}">
          <div v-if="row.promoType == 0">赠品促销</div>
          <div v-else-if="row.promoType == 1">单品促销</div>
          <div v-else-if="row.promoType == 2">套装促销</div>
          <div v-else-if="row.promoType == 3">总价促销</div>
          <div v-else>赠品促销</div>
        </template>
        </el-table-column>
        <el-table-column label="已发放令牌次数" width="120">
          <template slot-scope="scope">
            <div>{{ scope.row.sendNum }}</div>
          </template>
        </el-table-column>
        <el-table-column label="关联活动名称" width="250">
          <template slot-scope="scope">
            <div  v-for="(item,index) in scope.row.activityList" >
              {{ index+1 }}、{{ item.activityName }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="operation"
              style="width: 40px;margin-left: -10px;"
              @click="addToken(scope.row,'2')"
              v-if="tabActive!=2"
              >修改</el-button
            >
            <el-button
              type="text"
              class="operation"
              style="width: 40px;"
              @click="marketNowDetail(scope.row)"
              >数据明细</el-button
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button
              type="text"
              class="operation"
              style="width: 40px;"
              @click="addToken(scope.row,'3')"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.current"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="formData.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="pagination"
      ></el-pagination>
      <!-- 添加令牌 -->
      <el-dialog
        :title="addTitleToken"
        :visible.sync="addTokenVisible"
        destroy-on-close
        width="760px"
        @close="handleClosePlan"
        class="dialog-style"
      >
      <div  class="scrollable-div">
        <jd-tips color="blue" margin="0 0 20px 0">
          <p>    
           提示：商家需手工添加官方申请的令牌，以下填写的信息请务必与官方申请的信息一致，否则会导致活动异常，引起客诉
          </p>
        </jd-tips>
        <el-form
          :model="formSetToken"
          :rules="rulesToken"
          ref="formSetToken"
          label-width="155px"
          class="new-input-box"
        >
          <el-form-item label="令牌名称" prop="name">
            <el-input
              v-model="formSetToken.name"
              maxlength="25"
              show-word-limit
              placeholder="请输入令牌名称"
              style="width: 400px;"
              :disabled="editFalse || editFalse1"
            ></el-input>
          </el-form-item>
          <el-form-item label="令牌ID" prop="tokenId">
            <el-input
              v-model="formSetToken.tokenId"
               maxlength="19"
              placeholder="请输入令牌ID"
              style="width: 400px;"
              :disabled="editFalse || editFalse1"
            ></el-input>
          </el-form-item>
          <el-form-item label="令牌密钥" prop="secretKey">
            <el-input
              v-model="formSetToken.secretKey"
              placeholder="请输入令牌密钥"
              style="width: 400px;"
              :disabled="editFalse || editFalse1"
            ></el-input>
          </el-form-item>
          <el-form-item label="促销活动类型" prop="promoType" required>
            <el-select v-model="formSetToken.promoType" :disabled="editFalse || editFalse1" placeholder="请选择">
               <el-option label="赠品促销" :value="0"></el-option>
               <el-option label="单品促销" :value="1"></el-option>
               <el-option label="套装促销" :value="2"></el-option>
               <el-option label="总价促销" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="令牌有效时间" prop="time">
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="formSetToken.startTime"
                type="datetime"
                :placeholder="'开始日期'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px; font-size: 12px"
                class="time1"
                :clearable="false"
                :picker-options="startTimeOption"
                :disabled="editFalse || editFalse1"
              ></el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="formSetToken.endTime"
                type="datetime"
                :placeholder="'结束日期'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px; font-size: 12px"
                class="time2"
                :clearable="false"
                :picker-options="endTimeOption"
                :disabled="editFalse || editFalse1"
              ></el-date-picker>
              <i
                v-if="!editFalse && !editFalse1"
                class="el-icon-circle-close date_icon1"
                @click="clearTimeSendTime()"
              ></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
          </el-form-item>
          <el-form-item label="令牌描述">
            <el-input
                 type="textarea"
                 style="font-size: 14px;"
                 :rows="6"
                  maxlength="200"
                 placeholder="请输入令牌描述"
                v-model="formSetToken.description"
                :disabled="editFalse || editFalse1"
            ></el-input>
          </el-form-item>
          <el-form-item label="令牌中绑定的促销活动" >
             <span style="color: red;">用于软件内识别与记录，建议与官方申请令牌绑定的促销活动信息一致，整个促销活动时间需小于等于令牌有效时间，否则会导致促销活动失去参与限制</span>
          </el-form-item>
          <div v-for="(item,index) in focus"   style="background-color: #fafafa;padding: 10px;width: 565px;margin-left: 152px;margin-top: -12px;margin-bottom:20px;position: relative;">
            <div class="modification">促销活动{{index + 1}}</div>
             <span style="color: red;position: absolute;left: 60px;top:19px">*</span>
            <el-form-item label="促销活动时间" prop="times" style="" >
            <div class="my_select_time">
              <!-- :picker-options="startTimeOption" -->
              <el-date-picker
                prefix-icon="no_icon"
                v-model="item.startTime1"
                type="datetime"
                :placeholder="'开始日期'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px; font-size: 12px"
                class="time1"
                :clearable="false"
                :disabled="editFalse"
              ></el-date-picker>
              <div class="time_to_text">至</div>
              <!--  -->
              <el-date-picker
                prefix-icon="no_icon"
                v-model="item.endTime1"
                type="datetime"
                :placeholder="'结束日期'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px; font-size: 12px"
                class="time2"
                :clearable="false"
                :disabled="editFalse"
              ></el-date-picker>
              <i
                 v-if="!editFalse"
                class="el-icon-circle-close date_icon1"
                @click="clearTimeSendTime1()"
              ></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
            
            <span v-if="index>0 && !editFalse" style="margin-left: 30px;cursor: pointer;color: red;"  @click="deleteaCoupon(index)">
              <i  style="position: absolute;" class="el-icon-remove-outline"></i>
            </span>
            </el-form-item>
            <span style="color: red;position: absolute;left: 88px;top: 70px;">*</span>
            <el-form-item label="促销商品" prop="secret">
            <el-button
               style="width: 130px;"
               type="returnBtn"
               @click="promotional(item.sampleProductList,index)"
                >选择商品（{{item.sampleProductList.length}}）</el-button
            >
           </el-form-item>
           <span style="color: red;position: absolute;left: 88px;top: 119px;">*</span>
           <el-form-item label="赠品SKU" prop="secret">
            <div>
              <span>主SKU：</span>
              <el-button
                style="width: 130px;"
                type="returnBtn"
                @click="promotionalOne(item.sampleProductList1,index)"
                  >选择商品（{{item.sampleProductList1.length}}）</el-button
              >
            </div>
            <div>
              <span>子SKU/影分身</span>
              <el-tooltip
                  class="item"
                  effect="light"
                  content="子SKU/影分身用于核销校验主SKU+影分身标题，如无，则不需要填写"
                  placement="bottom"
                >
                  <span class="question-style">
                    <i class="el-icon-question"></i>
                  </span>
              </el-tooltip>
              <el-table
                :data="item.giveSkuRule"
                border
                :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
                :cell-style="{ 'text-align': 'left' }"
                style="width: 100%;"
              >
                <el-table-column label="主SKU" width="150">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.mainSkuId" placeholder="请输入" @input="scope.row.mainSkuId = handleMainSkuId($event)">
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="影分身SKU"  width="150">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.shadowSkuId" placeholder="请输入" @input="scope.row.shadowSkuId = handleShadowSkuId($event)">
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作"> 
                  <template slot-scope="scope">
                    <span class="delete-btn" @click="handleDeleteSKU(scope,index)">删除</span>
                  </template>
                </el-table-column>
              </el-table>
              <div>
                <div class="add-btn" @click="addSKU(index)">+添加</div>
              </div>
            </div>
           </el-form-item>
          </div>
          <div style="margin-left: 151px;margin-top: 20px;">
            <el-button  @click="addGif" width="80px"  :disabled="editFalse" >+添加</el-button>
          </div>
        </el-form>
        <div>
          
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button @click="handleClosePlan" width="80px">取 消</el-button>
          <el-button
            type="primary"
            style="margin-left: 8px"
            width="80px"
            @click="dialogFormSet('formSetToken')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 修改结束时间 -->
      <el-dialog title="修改结束时间" :visible.sync="dialogRevise" width="375px">
        结束时间
        <el-date-picker
          prefix-icon="no_icon"
          v-model="formEnd.planEndTime"
          type="datetime"
          :placeholder="'选择日期时间'"
          size="small"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 180px; font-size: 12px; margin-right: 12px"
          class="time1"
          :picker-options="endPlanOption"
          :clearable="false"
        ></el-date-picker>
        <template #footer>
          <el-button type="primary" @click="modifyConfirmation">确定</el-button>
        </template>
      </el-dialog>
      <!-- 数据明细 -->
      <el-dialog title="数据明细" :visible.sync="detailDialog" width="1200px">
        <input-form
          ref="inputRef"
          :inputData="inputDataDetail"
          :btnPosition1="true"
          @toParentVal="searchGiftCardDetail"
        ></input-form>
        <el-table
          v-loading="tableDetailLoading"
          :data="giftCardList"
          style="width: 100%;"
          :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
          :cell-style="{ 'text-align': 'left' }"
        >
          <el-table-column
            property="chaosPin"
            label="用户pin"
          ></el-table-column>
          <el-table-column
            property="sendNum"
            label="发放数量"
          ></el-table-column>
          <el-table-column
            property="sendTime"
            label="发放时间"
          ></el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleDetailSizeChange"
          @current-change="handleDetailCurrentChange"
          :current-page="formList.current"
          :page-sizes="[10, 30, 50, 100]"
          :page-size="formList.size"
          layout="total, sizes, prev, pager, next, jumper"
          class="pagination"
          :total="totalDetail"
        ></el-pagination>
      </el-dialog>
      <!-- 促销商品 -->
      <select-goods
        ref="selectGoods"
        :isShow="isShowSelectGoods"
        :isEdit="isEdit"
        :moduleType="true"
        :skuSearch="true"
        :xianz="false"
        :selectGoods="formDatas.sampleProductList"
        @close="selectGoodsChange"
        :disabled="isLook"
       ></select-goods>
       <!-- 赠品SKU -->
       <select-goods1
        ref="selectGoods1"
        :isShow="isShowSelectGoods1"
        :isEdit="isEdit1"
        :moduleType="true"
        :skuSearch="true"
        :xianz="false"
        :selectGoods="formDatas.sampleProductList1"
        @close="selectGoodsChange1"
        :disabled="isLook1"
       ></select-goods1>

    </div>
  </template>
  <script>
  import inputForm from "@/components/inputForm";
  import jdTips from "@/components/common/jdTips.vue";
  // import selectGoods from "@/components/selectGoodsMonitor2.vue";
  import selectGoods from "@/components/selectGoodsMonitor";
  // import selectGoods1 from "@/components/selectGoodsMonitor2.vue";
  import selectGoods1 from "@/components/selectGoodsMonitor";
  import {
    promoTokenSum, //令牌汇总
    promoTokenPage,//令牌分页
    addPromoTokenPage,//添加令牌
    updatePromoTokenPage,//修改令牌
    promoTokenSumDetail,//数据明细
    promoTokenDetail //令牌详情
  } from "@/api/integralCenter/tokenSummary.js";

  import {
    getGiftCardCount,
    getGiftCardPage,
    addGiftCard,
    importCardKey,
    updateGiftCard,
    stopGiftCard,
    getGiftCardDetailPage,
  } from "@/api/integralCenter/prizeCenter.js";
import { Overview } from "gojs";
  export default {
    components: {
      inputForm,
      jdTips,
      selectGoods,
      selectGoods1
    },
    filters: {
      statusStr(status) {
        return {
          0: "未知",
          1: "未开始",
          2: "进行中",
          3: "已结束",
          null: "null",
        }[status];
      },
      showNumber(num) {
        if (num > 0) {
          return num;
        } else {
          return 0;
        }
      },
    },
    props: {
      // 是否是查看数据
      isLook: {
        type: Boolean,
        default: false,
      },
      isLook1: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      const checkTime = (rule, value, callback) => {
        if (!this.formSetToken.startTime || !this.formSetToken.endTime) {
          callback(new Error("请选择计划时间"));
        } else {
          callback();
        }
      };
      const checkTime1 = (rule, value, callback) => {
        if (!this.formSetToken.startTime1 || !this.formSetToken.endTime1) {
          callback(new Error("请选择计划时间"));
        } else {
          callback();
        }
      };
      return {
        addTitleToken:'添加令牌',
        editFalse:false,
        editFalse1:false,
        //数据明细
        formList: {
          current: 1,
          size: 10,
          pin: "",
          startTime: "",
          endTime: "",
        },
        addNum:'1',
        tokenIndex:0,
        focus:[
          {
            startTime1:'',
            endTime1:'',
            sampleProductList: [], //促销商品
            sampleProductList1: [], //赠品SKU
            giveSkuRule: []
          },
        ],
        pendingNum:0, //待生效
        effectiveNum:0, //已生效
        formDatas:{
          sampleProductList: [], //促销商品
          sampleProductList1: [], //赠品SKU
        },
        // 用于区分是不是修改数据
        isEdit: false,
        isEdit1: false,
        //选择商品
        isShowSelectGoods: false,
        isShowReSelectGoods: false,
        //赠品SKU
        isShowSelectGoods1: false,
        isShowReSelectGoods1: false,
        tabActive:'1',
        addTokenVisible:false, //添加令牌
        uploadLoading: false,
        tableDetailLoading: false,
        imgList: [],
        isHideUpload: true,
        errorTip: "",
        waitNum: 0,
        goingNum: 0,
        //当前令牌
        inputData: [
          {
            name: "令牌名称:",
            val: "name",
            placeholder: "请输入",
          },
          {
            name: "令牌ID:",
            val: "tokenId",
            placeholder: "请输入",
          },
          {
            name: "时效状态:",
            val: "status",
            placeholder: "请选择",
            selectArr: [
              { label: "全部", id: '' },
              { label: "待生效", id: 1 },
              { label: "已生效", id: 2 },
            ],
          },
          {
            name: "创建时间:",
            myDate: true,
            val: ["createStartTime", "createEndTime"],
            startPlaceholder: "开始日期",
            endPlaceholder: "结束日期",
            isdefault: false,
          },
          {
            name: "令牌有效时间:",
            myDate: true,
            val: ["tokenStartTime", "tokenEndTime"],
            startPlaceholder: "开始日期",
            endPlaceholder: "结束日期",
            isdefault: false,
          }
         ],
         //历史令牌
         inputDatas:[{
            name: "令牌名称:",
            val: "name",
            placeholder: "请输入",
          },
          {
            name: "令牌ID:",
            val: "tokenId",
            placeholder: "请输入",
          },
          {
            name: "创建时间:",
            myDate: true,
            val: ["createStartTime", "createEndTime"],
            startPlaceholder: "开始日期",
            endPlaceholder: "结束日期",
            isdefault: false,
          },
          {
            name: "令牌有效时间:",
            myDate: true,
            val: ["tokenStartTime", "tokenEndTime"],
            startPlaceholder: "开始日期",
            endPlaceholder: "结束日期",
            isdefault: false,
          }],
         formData: {
           current: 1,
           size: 10,
           status: 0,
           name: "",
           createStartTime: "",
           createEndTime: "",
           tokenStartTime: "",
           tokenEndTime: "",
           tokenId:'',
           type:1
         },
        total: 0,
        dialogFormVisible: false,
        tableLoading: false,
        tableData: [],
        dialogRevise: false,
        detailDialog: false,
        formEnd: {
          id: "",
          planEndTime: "",
        },
        formSet: {
          planName: "",
          startTime: "",
          endTime: "",
          activateType: 0,
          planImg:
            "https://yeion-public.s3.cn-north-1.jdcloud-oss.com/gift_card.png",
          description: "",
          quantityTotal: "",
          batchId: "",
        },
        //令牌数据定义
        formSetToken: {
          name: "",
          tokenId:'',
          startTime: "",
          endTime: "",
          secretKey:'',
          description:'',
          detailList:[],
          // startTime1: "",
          // endTime1: "",
          promoType: 0,// 促销活动类型 0赠品促销 1单品促销 2套装促销 3总价促销
        },
        inputDataDetail: [
          {
            name: "用户pin",
            val: "pin",
            placeholder: "请输入",
          },
          {
            name: "发放时间",
            myDate: true,
            val: ["startTime", "endTime"],
            startPlaceholder: "开始日期",
            endPlaceholder: "结束日期",
            isdefault: false,
          },
        ],
        fileList: [],
        giftCardList: [],
        totalDetail: 0,
        rules: {
          planName: [
            { required: true, message: "请输入计划名称", trigger: "blur" },
            { min: 1, max: 12, message: "不能超过 12 个字符", trigger: "blur" },
          ],
          startTime: { required: true, validator: checkTime, trigger: "change" },
          description: [
            { required: true, message: "请填写礼品卡描述", trigger: "blur" },
          ],
          activateType: [
            { required: true, message: "请选择激活方式", trigger: "change" },
          ],
        },
        //令牌规则校验
        rulesToken:{
          name: [//令牌名称
            { required: true, message: "用于软件内识别，建议与官方申请信息一致", trigger: "blur" },
            { min: 1, max: 25, message: "不能超过 25 个字符", trigger: "blur" },
         ],
         tokenId:{ required: true, message: "务必与官方申请信息一致", trigger: "blur"},
         secretKey:{ required: true, message: "务必与官方申请信息一致", trigger: "blur"},
         time: { required: true, message: "务必与官方申请信息一致,令牌有效时间需涵盖整个促销活动时间,否则会导致促销活动失去参与限制", validator: checkTime, trigger: "blur"},
        //  times:{required: true, message: "请填写时间",validator: checkTime1, trigger: "change"}
        },
        startTimeOption: {
          disabledDate: (date) => {
            let endTime = this.formSet.endTime;
            let time = date.getTime();
            return (
              time < new Date().getTime() - 24 * 60 * 60 * 1000 ||
              time > new Date(endTime).getTime()
            );
          },
        },
        endTimeOption: {
          disabledDate: (date) => {
            let startTime = this.formSet.startTime;
            let time = date.getTime();
            return time < new Date(startTime).getTime();
          },
        },
        endPlanOption: {
          disabledDate: (date) => {
            let endTime = this.enPlanTime;
            let time = date.getTime();
            return time < new Date(endTime).getTime();
          },
          selectableRange: "00:00:00 - 23:59:59"
        },
      };
    },
    computed: {
      descLimit() {
        return (desc) => {
          if (desc) {
            return desc.length > 20 ? desc.substring(0, 20) + "..." : desc;
          } else {
            return "";
          }
        };
      },
      getStatusIcon() {
        return (status) => {
          let className = "state ";
          switch (status) {
            case 0:
              className = "";
              break;
            case 1:
              className += "y1";
              break;
            case 2:
              className += "y2";
              break;
            case 3:
              className += "y3";
              break;
          }
          return className;
        };
      },
      getChangePin() {
        return (pin) => {
          if (pin) {
            return pin.charAt(0) + "***" + pin.charAt(pin.length - 1);
          } else {
            return "-";
          }
        };
      },
    },
    watch: {
      "formEnd.planEndTime"(planEndTime) {
        const selectTime = new Date(planEndTime).getTime();
        const enPlanTime = new Date(this.enPlanTime);
        const currentTime = enPlanTime.getTime();
        if (selectTime <= currentTime) {
          const hours = String(enPlanTime.getHours()).padStart(2, "0");
          const minutes = String(enPlanTime.getMinutes()).padStart(2, "0");
          const seconds = String(enPlanTime.getSeconds()).padStart(2, "0");
          this.endPlanOption.selectableRange = `${hours}:${minutes}:${seconds} - 23:59:59`;
        } else {
          this.endPlanOption.selectableRange = `00:00:00 - 23:59:59`;
        }
      },
    },
    mounted() {
      //令牌汇总
      this.promoTokenTatal();
      this.getGiftCardCounts();
      this.$nextTick(() => {
        this.$refs.inputForm.formSearch();
      });
    },
    methods: {
      addSKU(index) {
        if(this.focus[index].giveSkuRule.length==20) {
          this.$message.warning("最多添加20个")
          return
        }
        this.focus[index].giveSkuRule.push({
          mainSkuId: "",
          shadowSkuId: ""
        })  
      },
      // SKU删除
      handleDeleteSKU(scope,current) {
        this.focus[current].giveSkuRule.splice(scope.$index,1)  
      },
    //数据明细
     async getGiftCardDetail() {
        this.tableDetailLoading = true;
        try {
          const res = await promoTokenSumDetail(this.formList);
          if (res.code == 1) {
            this.tableDetailLoading = false;
            this.giftCardList = res.data.records;
            this.totalDetail = Number(res.data.total);
          } else {
            this.tableDetailLoading = false;
          }
        } catch (error) {
          this.tableDetailLoading = false;
        }
      },
      marketNowDetail(row) {
        //数据明细
        console.log(row,'65464');
        this.formList.promoTokenId = row.id;
        this.detailDialog = true;
        this.formList.current = 1;
        this.formList.size = 10;
        this.$nextTick(() => {
          this.$refs.inputRef.formSearch();
        });
      },
      //数据明细
      searchGiftCardDetail(val) {
        this.formList.current = 1;
        this.formList.size = 10;
        this.formList.pin = val.pin;
        this.formList.startTime = val.startTime==null?'':val.startTime;
        this.formList.endTime = val.endTime == null ? '':val.endTime ;
        this.getGiftCardDetail();
      },
     //删除
     deleteaCoupon(item){
      this.focus.splice(item, 1);
     },
     //添加选项
     addGif(){
      this.focus.push({
        startTime1:'',
        endTime1:'',
        sampleProductList: [], //促销商品
        sampleProductList1: [], //赠品SKU
        giveSkuRule: []
      });
     },
     //令牌汇总
     async promoTokenTatal(){
       const res = await promoTokenSum();
       if(res.code === 1){
            const { waitNum: pendingNum, goingNum: effectiveNum } = res.data;
            this.pendingNum = pendingNum; // 待生效
            this.effectiveNum = effectiveNum; // 已生效
       }
     } ,
     //令牌分页
     async getList() {
        try {
          this.tableLoading = true;
          const res = await promoTokenPage(this.formData);
          if (res.code == 1) {
            this.tableLoading = false;
            this.tableData = res.data.records;
            this.total = Number(res.data.total);
          }
         } catch (error) {
           this.tableLoading = false;
         }
     },
     search(val) {
        this.formData.current = 1;
        this.formData.size = 10;
        this.formData.status = val.status;
        this.formData.name = val.name;
        this.formData.createStartTime = val.createStartTime === null ? '': val.createStartTime;
        this.formData.createEndTime = val.createEndTime === null ? '': val.createEndTime;
        this.formData.tokenStartTime = val.tokenStartTime === null ? '': val.tokenStartTime;
        this.formData.tokenEndTime = val.tokenEndTime === null ? '': val.tokenEndTime;
        this.formData.tokenId = val.tokenId;
        this.getList();
     },
     //当前令牌和历史令牌时间切换
     handleClick(val){
        this.formData = {
          status:"",
          name:'',
          createStartTime:'',
          createEndTime:'',
          tokenStartTime:'',
          tokenEndTime:"",
          tokenId:'',
          current:1,
          size:10
        }
        if(val.name ==='1'){
          this.formData.type = 1
        }else{
          this.formData.type = 2
        }
        this.getList();
       },

     //时间清空
     clearTimeSendTime() {
         this.formSetToken.startTime = "";
         this.formSetToken.endTime = "";
     },
     clearTimeSendTime1() {
        this.formSetToken.startTime1 = "";
        this.formSetToken.endTime1 = "";
    },
    // 选择商品回显
    selectGoodsChange(data) {
      if(data){
        this.focus[this.tokenIndex].sampleProductList = data
      }
      this.isShowSelectGoods = false;
    },
    selectGoodsChange1(data) {
      if(data){
        this.focus[this.tokenIndex].sampleProductList1 = data
      }
      this.isShowSelectGoods1 = false;
    },
    promotional(val,index){
      this.isShowSelectGoods = true;
      this.formDatas.sampleProductList = val
      this.tokenIndex = index

    },
    promotionalOne(val,index){
      this.isShowSelectGoods1 = true;
      this.formDatas.sampleProductList1 = val
      this.tokenIndex = index
    },
    //添加令牌
    addToken(val,e){
        const isAdding = e ==='1' //标识是添加还是编辑
        this.addNum = e
        if(isAdding){
           this.addTitleToken = '添加令牌'
           this.editFalse = false
           this.editFalse1 = false;
           this.formSetToken={
             name: "",
             tokenId:'',
             startTime: "",
             endTime: "",
             description: "",
             quantityTotal: "",
             secretKey:'',
             promoType: 0
            //  startTime1: "",
            //  endTime1: "",
          }
          this.formDatas={
             sampleProductList: [], //促销商品
             sampleProductList1: [], //赠品SKU
           }
           this.focus=[
             {
               startTime1:'',
               endTime1:'',
               sampleProductList: [], //促销商品
               sampleProductList1: [], //赠品SKU
               giveSkuRule: []
             }
           ]
        }else{
          if(e == 3) {
            this.addTitleToken = '令牌详情'
            this.editFalse1 = true
            this.editFalse = true
          }else if(e == 2){
            if(val.status==2){
              this.editFalse1 = true
            }else{
              this.editFalse1 = false
            }
            this.editFalse = false
            this.addTitleToken = '修改令牌'
          }
          //编辑
          this.formSetToken={
             name: val.name,
             tokenId:val.tokenId,
             startTime: val.startTime,
             endTime: val.endTime,
             description: val.description,
             secretKey:val.secretKey,
             promoType:val.promoType || 0
          }
          this.formSetToken.id = val.id //修改对应的id
          let paramsId = {
            id:val.id
          }
          //商品回显
          promoTokenDetail(paramsId).then((res)=>{
            const { detailList } =res.data
            this.focus= []
            if(detailList.length>0){
              detailList.forEach((item,index)=>{ 
                const { promoSkuList, giveSkuList, promoStartTime, promoEndTime,shadowSkuList } = item;
                this.formDatas.sampleProductList = promoSkuList; // 促销商品
                this.formDatas.sampleProductList1 = giveSkuList; // 促销商品
                this.focus.push(  {
                      startTime1:'',
                      endTime1:'',
                      sampleProductList: [], //促销商品
                      sampleProductList1: [], //赠品SKU
                      giveSkuRule: []
                 })
                this.focus[index].sampleProductList = promoSkuList;
                this.focus[index].sampleProductList1 = giveSkuList;
                this.focus[index].startTime1 = promoStartTime;
                this.focus[index].endTime1 = promoEndTime;
                this.focus[index].giveSkuRule = shadowSkuList.map((item)=>{
                  let obj = {
                    mainSkuId: "",
                    shadowSkuId: ""
                  }
                  obj.mainSkuId = item.mainSkuId
                  obj.shadowSkuId = item.shadowSkuId
                  return obj
                });
             }) 
            }   
          })
        }
        this.addTokenVisible = true
    }, 
     //添加令牌取消事件
     handleClosePlan(){
      this.$refs.formSetToken.resetFields();
      this.addTokenVisible = false;
     },
      async getGiftCardCounts() {
        const res = await getGiftCardCount();
        if (res.code == 1) {
          this.waitNum = res.data.waitNum;
          this.goingNum = res.data.goingNum;
        } else {
          this.$message.error(res.message);
        }
      },
      handleCreateByMe() {
        this.formData.current = 1;
      },
      handleEdit(row) {
        this.formEnd.id = row.id;
        this.formEnd.planEndTime = row.endTime;
        this.enPlanTime = row.endTime;
        this.dialogRevise = true;
      },
      async modifyConfirmation() {
        const res = await updateGiftCard(this.formEnd);
        if (res.code == 1) {
          this.dialogRevise = false;
          this.$message.success("操作成功");
          this.getList();
        } else {
          this.$message.error(res.message);
        }
      },
      //分页变化事件
      handleSizeChange(val) {
        this.formData.size = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.formData.current = val;
        this.getList();
      },
      //分页变化事件
      handleDetailSizeChange(val) {
        this.formList.size = val;
        this.getGiftCardDetail();
      },
      handleDetailCurrentChange(val) {
        this.formList.current = val;
        this.getGiftCardDetail();
      },
      dialogFormSet(formSetToken) {
        if(this.editFalse){this.addTokenVisible = false; return}
        let Array = [];
        this.$refs[formSetToken].validate(async (valid) => {
          //商品遍历
          this.focus.forEach((e,index)=>{
             let params = {}
             params.promoStartTime = e.startTime1; 
             params.promoEndTime = e.endTime1;
             params.promoSku =  this.focus[index].sampleProductList.map((e,i)=>{
                return e.skuId
             }).join(',');
             params.giveSku =  this.focus[index].sampleProductList1.map((e,i)=>{
                return e.skuId
             }).join(',');
             params.giveSkuRule = JSON.stringify(this.focus[index].giveSkuRule)
             Array.push(params);
          })
          if (valid) {
            let flag = false
            let flag1 = false
            let flag2 = false
            this.focus.forEach((item)=>{
              if(item.sampleProductList1.length==0) {
                flag = true
              }
              if(item.giveSkuRule.length>0) {
                if(item.giveSkuRule.length) {
                  item.giveSkuRule.some((row)=>{
                    if(!row.mainSkuId) {
                      flag1 = true
                    }
                    if(!row.shadowSkuId) {
                      flag2 = true
                    }
                  })
                }
              }
            })
            if(flag) {
              this.$message.warning("请先选择赠品SKU")
              return
            }
            if(flag1) {
              this.$message.warning("请先输入主SKU")
              return
            }
            if(flag2) {
              this.$message.warning("请先输入影分身SKU")
              return
            }
            this.formSetToken.detailList = Array;
            if(this.addNum == '1'){
              var res = await addPromoTokenPage(this.formSetToken);
            }else{
              var res = await updatePromoTokenPage(this.formSetToken);
            }
            if (res.code == 1) {
              this.addTokenVisible = false;
              this.$nextTick(() => {
                this.$refs.inputForm.formSearch();
              });
            }else{
              this.$message.error(res.message)
            }
          } else {
            return false;
          }
        });
      },
      handleMainSkuId(val){
        return val.replace(/[^\d]/g, '');
      },
      handleShadowSkuId(val){
        return val.replace(/[^0-9,]/g, '');
      }
    },
  };
  </script>
  <style lang="scss" scoped>
  .modification{
    position: absolute;
    top: 79px;
    left: -68px;
  }
  .topTip {
    display: flex;
    align-items: center;
    position: relative;
    background: #fafafa;
    height: 120px;
    margin: 30px;
    .beans {
      margin: 20px;
    }
  }
  .operation {
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #7b61ff;
    }
  }
  .pagination {
    margin: 20px;
    text-align: right;
  }
  .import {
    position: relative;
    display: flex;
    &-tip {
      color: #ff0000;
    }
    &-text {
      margin-top: 8px;
      line-height: 18px;
    }
    &-right {
      position: absolute;
      top: 0;
      left: 95px;
      // margin-left: -103px;
    }
  }
  .upload {
    display: flex;
    align-items: center;
    /deep/.el-upload--picture-card {
      width: 100px;
      height: 100px;
      line-height: 107px;
    }
    /deep/.el-upload-list--picture-card .el-upload-list__item {
      width: 100px;
      height: 100px;
    }
    .planImg {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 12px;
      &-tip {
        color: #999999;
        font-size: 12px;
        line-height: 20px;
      }
    }
  }
  .footer-btn {
    margin-top: 20px;
    text-align: center;
  }
  .copy {
    display: flex;
    align-items: center;
  }
  .state {
    padding: 6px 10px;
    border-radius: 17px;
  }
  .y1 {
    color: #02b1ff;
    background-color: #e6f7ff;
  }
  .y2 {
    color: #f36f39;
    background: #fef1ec;
  }
  .y3 {
    color: #5b5b5b;
    background: #f1f1f1;
  }
  .hide ::v-deep .el-upload--picture-card {
    display: none;
  }
  .remark-tip {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;   //设置超出几行省略内容
    text-overflow:ellipsis;
    overflow: hidden;
  }
  .question-style {
    margin-left: 4px;
    color: #666;
    cursor: pointer;
  }
  .delete-btn,.add-btn {
    color: #7b61ff;
    cursor: pointer;
  }
  .scrollable-div {
    max-height: 600px; /* 设定最大高度 */
    // overflow-x: hidden; 
    // overflow-y: auto; /* 垂直方向上添加滚动条 */
  }
  

  </style>
  <style lang="scss">
  .dialog-style {
    .el-dialog__body {
      overflow-y: auto;
    }
  }
  </style>
  